import { Box, Stack, Typography } from "@mui/material";
import { Chart } from "react-google-charts";

export interface ITaskData {
    id: string;
    name: string;
    start: string;
    end: string;
    hours: number;
    realHours?: number;
    estimated: number;
    type:
        | "app"
        | "dashboard"
        | "landing"
        | "login"
        | "chat"
        | "checkout"
        | "password";
    category: "module" | "requirement" | "feature" | "milestone";
    parent?: string;
    expanded?: boolean;
    warning?: boolean;
    position?: number;
    dependencies?: string[];
    completed?: number;
    isMilestone?: boolean;
}

interface IGanttChartProps {
    dataGraph: (
        | (string | number | Date | null)[]
        | {
              type: string;
              label: string;
          }[]
    )[];
}

const GanttChart = ({ dataGraph }: IGanttChartProps) => {
    const hasConcludedResource = dataGraph.slice(1).some((row) => {
        if (Array.isArray(row)) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            return row.includes("Concluído");
        }
        return false;
    });

    const MAX_LABEL_LENGTH = 60;

    const truncateLabel = (label: string): string => {
        return label.length > MAX_LABEL_LENGTH
            ? `${label.slice(0, MAX_LABEL_LENGTH)}...`
            : label;
    };

    const formattedDataGraph = dataGraph.map((row, index) => {
        if (index === 0 || !Array.isArray(row)) return row;

        const newRow = [...row];
        const taskName = newRow[1];

        if (typeof taskName === "string") {
            newRow[1] = truncateLabel(taskName);
        }

        return newRow;
    });

    // Configura as paletas baseadas na presença de "Concluído"
    const palette = hasConcludedResource
        ? [
              {
                  color: "#FF0000",
                  dark: "#B22222",
                  light: "#FFD2D2",
              },

              {
                  color: "#32CD32",
                  dark: "#228B22",
                  light: "#98FB98",
              },
              {
                  color: "#FFA500",
                  dark: "#FF8C00",
                  light: "#FFD700",
              },
              {
                  color: "#6E59A5",
                  dark: "#3730a3",
                  light: "#a5b4fc",
              },
          ]
        : [
              {
                  color: "#FF0000",
                  dark: "#B22222",
                  light: "#FFD2D2",
              },
              {
                  color: "#6E59A5",
                  dark: "#3730a3",
                  light: "#a5b4fc",
              },
              {
                  color: "#FFA500",
                  dark: "#FF8C00",
                  light: "#FFD700",
              },
          ];
    return (
        <Stack
            sx={{
                borderRadius: 1,
            }}
        >
            <Box sx={{ p: 2 }}>
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                    }}
                >
                    <Typography
                        variant="h6"
                        component="h2"
                        color="text.primary"
                    >
                        {"Gráfico de Gantt"}
                    </Typography>
                </Box>
            </Box>

            {dataGraph && (
                <Box
                    sx={{
                        position: "relative",
                        overflow: "auto",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <Chart
                        chartType="Gantt"
                        data={formattedDataGraph}
                        width="100%"
                        height="auto"
                        options={{
                            gantt: {
                                trackHeight: 30,
                                barHeight: 20,
                                labelStyle: {
                                    fontName: "inherit",
                                    fontSize: 12,
                                },
                                percentEnabled: true,
                                sortTasks: false,
                                labelMaxWidth: 400,
                                barCornerRadius: 3,
                                palette,
                                innerGridTrack: { fill: "#f8fafc" },
                                innerGridDarkTrack: { fill: "#f1f5f9" },
                            },
                            backgroundColor: "transparent",
                            locale: "pt-BR",
                            hAxis: {
                                format: "dd/MM/yyyy",
                            },
                        }}
                        /*
                        TODO: Adicionar eventos do gráfico aqui:
                            chartEvents={[
                                {
                                    eventName: "select",
                                    callback: ({ chartWrapper }) =>
                                        handleChartSelect(chartWrapper),
                                },
                            ]}
                        */
                    />
                </Box>
            )}
        </Stack>
    );
};

export default GanttChart;
